import React, { useState } from "react";
import PropTypes from "prop-types";

import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import "./DatePicker.css";

import { DateRangePicker, createStaticRanges } from "react-date-range";
import {
    subDays,
    addDays,
    endOfDay,
    startOfDay,
    startOfMonth,
    endOfMonth,
    addMonths,
    startOfWeek,
    endOfWeek,
    startOfYear,
    endOfYear,
    addYears
} from "date-fns";
import { useSelector } from "react-redux";

const DatePicker = ({ onChange }) => {
    const verticalOrHorizontal = useSelector(state => state.verticalOrHorizontal)

    const defineds = {
        startOfWeek: startOfWeek(new Date()),
        endOfWeek: endOfWeek(new Date()),
        startOfLastWeek: startOfWeek(addDays(new Date(), -7)),
        endOfLastWeek: endOfWeek(addDays(new Date(), -7)),
        startOfToday: startOfDay(new Date()),
        startOfLastSevenDay: startOfDay(addDays(new Date(), -7)),
        startOfLastThirtyDay: startOfDay(addDays(new Date(), -30)),
        startOfLastNintyDay: startOfDay(addDays(new Date(), -90)),
        endOfToday: endOfDay(new Date()),
        startOfYesterday: startOfDay(addDays(new Date(), -1)),
        endOfYesterday: endOfDay(addDays(new Date(), -1)),
        startOfMonth: startOfMonth(new Date()),
        endOfMonth: endOfMonth(new Date()),
        startOfLastMonth: startOfMonth(addMonths(new Date(), -1)),
        endOfLastMonth: endOfMonth(addMonths(new Date(), -1)),
        startOfYear: startOfYear(new Date()),
        endOfYear: endOfYear(new Date()),
        startOflastYear: startOfYear(addYears(new Date(), -1)),
        endOflastYear: endOfYear(addYears(new Date(), -1))
    };

    const [state, setState] = useState([
        {
            startDate: subDays(new Date(), 7),
            endDate: new Date(),
            key: "selection"
        }
    ]);

    const sideBarOptions = () => {
        const customDateObjects = [
            {
                label: "Bu gün",
                range: () => ({
                    startDate: defineds.startOfToday,
                    endDate: defineds.endOfToday
                })
            },
            {
                label: "Dünən",
                range: () => ({
                    startDate: defineds.startOfYesterday,
                    endDate: defineds.endOfYesterday
                })
            },
            {
                label: "Son 7 Gün",
                range: () => ({
                    startDate: defineds.startOfLastSevenDay,
                    endDate: defineds.endOfToday
                })
            },
            {
                label: "Son 30 Gün",
                range: () => ({
                    startDate: defineds.startOfLastThirtyDay,
                    endDate: defineds.endOfToday
                })
            },
            {
                label: "Bu Ay",
                range: () => ({
                    startDate: defineds.startOfMonth,
                    endDate: defineds.endOfMonth
                })
            },
            {
                label: "Keçən Ay",
                range: () => ({
                    startDate: defineds.startOfLastMonth,
                    endDate: defineds.endOfLastMonth
                })
            },
        ];

        return customDateObjects;
    };

    const sideBar = sideBarOptions();
    const staticRanges = [
        ...createStaticRanges(sideBar)
    ];

    const handleOnChange = ranges => {
        const { selection } = ranges;
        onChange(selection);
        setState([selection]);
    };

    return (
        <DateRangePicker
            onChange={handleOnChange}
            rangeColors={'#6F52EA'}
            showSelectionPreview={true}
            moveRangeOnFirstSelection={false}
            months={2}
            ranges={state}
            staticRanges={staticRanges}
            direction={verticalOrHorizontal}
            inputRanges={[]}
            weekStartsOn={1}
            // dateDisplayFormat={'dd-MM-yyyy'}
        />
    );
};

DatePicker.propTypes = {
    onChange: PropTypes.func
};

export default DatePicker;
